const map = {
  // 客商一览
  customersManagementList: () =>
    import('@/views/customersManagement/index'), // 客商一览
  customersManagementDetail: () =>
    import('@/views/customersManagement/Detail') // 客商一览
}

export default map
